import React, { useEffect, useState } from 'react'
import { appNames } from '../../constants/appNames';
import ForestreetModal from '../Modal/ForestreetModal';
import { ButtonGroup, ButtonIcon, Card, Icon, CardV2, Tooltip } from 'pepsico-ds';
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit } from '../../utils/utils';
import InfoIcon from '../Icons/InfoIcon';
import { showChartDisplayError, useButtonItemsArray, vlaidateLandingPageFilters } from './CardUtils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useSelector } from 'react-redux'
import ResilincModal from '../Modal/ResilincModal';
import VeridionModal from '../Modal/VeridionModal';
import CustomButtons from './CustomButtons';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

function ForestreetCard({ data, capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    const [openModal, setOpenModal] = useState(false)
    // const [userData, setUserData] = useState({})
    const userData = useSelector((state) => state?.localData?.data?.oktaUserData);
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [veridionCustomBtn, setVeridionCustomBtn] = useState([])
    const [appName, setAppName] = useState('Forestreet');
    // useEffect(() => {
    //     async function getUserInfo() {
    //         const userInfo = await getOktaUserClaims(getOktaAuth())
    //         setUserData(userInfo)
    //     }
    //     getUserInfo()

    // }, [])
    /* istanbul ignore next */
    useEffect(() => {
        // let userInfoEmailID = JSON.parse(atob(localStorage.getItem('userInfoEmailID')));
        const encodedEmailId = localStorage.getItem('userInfoEmailID')
        let userInfoEmailID = ''
        if(encodedEmailId){
            try{
                userInfoEmailID = JSON.parse(atob(encodedEmailId));
            }  catch (error) {
                userInfoEmailID = '';
            }
        } 
        if (data && Object.keys(data).length > 0) {
            const tempbuttonGroupItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
            })) : [];
            // setVeridionCustomBtn(data?.apps?.map(app => {
            //     if (app.app === "Veridion (V)") {
            //         return { ...app, url: `https://platform.veridion.com/?sso_hint=${userInfoEmailID}` };
            //     }
            //     return app;
            // }));
            setVeridionCustomBtn((data?.apps ?? []).filter(app => app.app !== "Veridion (V)"));
            setButtonGroupItems(tempbuttonGroupItems)
        }
    }, [data])
    
    const buttonGroupDropdownItems = useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability);
    // const buttonGroupDropdownItems = [
    //     { icon: "bar_chart", onClick: () => console.log("Bar chart clicked") },
    //     ...buttonGroupItems
    //         // .filter((item) => item.label !== "AMESA Contract Analytics" && item.label !== "AMESA PBI App")
    //         .map((item) => ({
    //             ...item,
    //             // label: item.label + " - KPIs",
    //             disabled: !item.chartDisplay,
    //             onClick: () => {
    //                 if (item.chartDisplay) {
    //                     setAppName(item.label);
    //                     vlaidateLandingPageFilters(false)
    //                 } else {
    //                     showChartDisplayError()
    //                 }

    //             },
    //         })),
    // ];
    // console.log('FSbuttonGroupDropdownItems', buttonGroupDropdownItems)
    // console.log('FSappName', appName)
    // console.log('capability', capability)
    // console.log('appNames', appNames.forestreet)
    // console.log('openModal', openModal)
    const enableChartDisplayButton = [appNames.forestreet, appNames.resilinc, appNames.veridion].includes(capability) &&
        buttonGroupDropdownItems.length < 3 && buttonGroupDropdownItems?.[1]?.chartDisplay;
    /* istanbul ignore next */
    function renderSuppliersInfo() {
        if (capability === appNames.forestreet) {
            return data.suppliersAccepted
                ? <>{formatNumberWithCommas(data?.suppliersAccepted)}<sup><InfoIcon text="This data is only for published Studies" direction='right' /></sup></>
                : <>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></>;
        }

        if (capability === appNames.resilinc) {
            return data.avgResiliencyRisk
                ? <>{data?.avgResiliencyRisk ? Number(parseFloat(data.avgResiliencyRisk).toFixed(2)) : 'N/A'}</>
                : <>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></>;
        }

        return <>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></>;
    }

    return (
        <>
            <div className="kpi-card-header">
                                    <div className="kpi-card-title">
                                        {data?.title}
                                        {
                                            data?.edfintegrated &&
                                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                            </Tooltip>
                                        }
                                    </div>
                                    <div>
                                        {
                                            buttonGroupDropdownItems.length === 2 ?
                                                <div className="kpi-card-header-icons">
                                                    <ButtonIcon
                                                        icon="bar_chart"
                                                        disabled={disabled}
                                                        label=""
                                                        onClick={
                                                            () => {
                                                                if (!enableChartDisplayButton) {
                                                                    showChartDisplayError()
                                                                } else {
                                                                    if(capability===appNames.forestreet) {
                                                                        setAppName("Forestreet (F)");
                                                                    }
                                                                    vlaidateLandingPageFilters(true, landingPageFilters, setOpenModal, openModal, capability)
                                                                }
                                                            }}
                                                        size="medium"
                                                        type="default" />
                                                </div>
                                                :
                                                <ButtonGroup
                                                    groupDisabled = {disabled}
                                                    itemCount={1}
                                                    items={buttonGroupDropdownItems}
                                                    showMore
                                                    size="medium"
                                                    className="kpiCardButtomGroup"
                                                />
                                        }
                                    </div>
                                </div>
                                {
                                    <div className="kpi-card-middle-content">
                                        <div className="kpi-card-middle-content-left" style={{ width: capability === appNames.forestreet?'75%':'70%' }}>
                                            <div className="kpi-card-alphanumeric-value">
                                                <div className='kpi-card-numeric-value' style={{ fontSize: 50 }}>
                                                    {renderSuppliersInfo()}
                                                </div>
                                            </div>
                                            <div>
                                                <div className="kpi-card-numeric-value-tagline">
                                                    {data.description}
                                                    { 
                                                        capability === appNames.forestreet &&
                                                        <span style={{ fontWeight: 700 }}>{data?.showVeridion && <>: F-{data.foreStreetCount?data.foreStreetCount:0}</>}
                                                            {data?.showVeridion && <> | V-{data.veridionCount?data.veridionCount:0}</>}
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="kpi-card-last-update" style={{ width: '100%', textAlign: 'left' }}>{data?.lastUpdate && data?.refreshFrequency? `${data.lastUpdate} | ${data.refreshFrequency}`: data?.lastUpdate || data?.refreshFrequency || ''}</div>
                                        </div>
                                        {
                                            capability === appNames.forestreet ?
                                                <div className="kpi-card-middle-content-right">
                                                    <div className="supplier-discovery-card-text">Shortlist %</div>
                                                    <div className="supplier-discovery-card-value" style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <span>{data?.showVeridion && <>F-</>}{data.foreStreetPercentage?(data.foreStreetPercentage+"%"):"-"}</span>
                                                        {data?.showVeridion && <span>V-{data.veridionPercentage?(data.veridionPercentage+"%"):"-"}</span>}
                                                    </div>
                                                </div>
                                                : capability === appNames.resilinc ?
                                                    <div className="kpi-card-middle-content-right">
                                                        <div className="supplier-discovery-card-value">{data.tier1Supplier}</div>
                                                        <div className="supplier-discovery-card-text"># Tier 1 Suppliers</div>
                                                    </div> : ''
                                        }
                                    </div>
                                }
                                
                                <div className="kpi-card-footer">
                                    <CustomButtons appList={veridionCustomBtn} disabled={disabled}/>
                                </div>
            
            {
                openModal && capability == appNames.resilinc && <ResilincModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {/* && appName == "Forestreet (F)" */}
            {
                openModal && capability == appNames.forestreet && appName == "Forestreet (F)" && <ForestreetModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }

            {   
                openModal && capability == appNames.forestreet && appName == "Forestreet (F)" && <ForestreetModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName ={appName} />
            }
            {
                openModal && capability == appNames.forestreet && appName == "Veridion (V)" && <VeridionModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName ={appName}/>
            }
        </>
    )
}

export default ForestreetCard